import { render } from "./AutoDialog.vue?vue&type=template&id=d561ab1e&scoped=true"
import script from "./AutoDialog.vue?vue&type=script&lang=js"
export * from "./AutoDialog.vue?vue&type=script&lang=js"

import "./AutoDialog.vue?vue&type=style&index=0&id=d561ab1e&lang=scss&scoped=true"

import exportComponent from "/Users/ilss0902/PorjectCenter/Cloudmobile/雲端POS_V2/code/pos_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d561ab1e"]])

export default __exports__